import React from 'react';
import querystring from 'querystring';

import { Main, MainHeader, Body } from 'components/Main';
import { Panel, PanelTop } from 'components/Panel';
import { Table, Th, Td } from 'components/Table';
import PlayerLink from 'components/PlayerLink';
import { dp } from 'components/util';

export default class BattingPositionLeadersPage extends React.Component {
    componentDidMount() {
        if (window !== undefined) {
            window.addEventListener('popstate', event => {
                let params = {};
                if (window.location.search) {
                    params = querystring.parse(window.location.search.substring(1));
                }
                this.props.browserBack(window.location.pathname, params);
            });
        }
    }

    render() {
        const { teams } = this.props;
        return (
            <Main>
                <MainHeader />
                <Body id="batting-position-leaders-page">
                    <Panel border>
                        <PanelTop title="Batting Position Leaders" />
                        <BattingPositionLeadersTable teams={teams} />
                    </Panel>
                </Body>
            </Main>
        );
    }
}

const BattingPositionLeadersTable = ({ teams }) => (
    <Table striped hover>
        <thead>
            <tr>
                <Th min="8">Position</Th>
                <Th left>Name</Th>
                <Th min="2">Runs</Th>
                <Th priority="2">Best</Th>
                <Th priority="2">100s</Th>
                <Th priority="2">50s</Th>
                <Th priority="2">4s</Th>
                <Th priority="2">6s</Th>
                <Th short="3" value="Inns">
                    Innings
                </Th>
                <Th priority="2" short="3" value="No">
                    Not Outs
                </Th>
                <Th min="2" short="2" value="Avg">
                    Average
                </Th>
                <Th priority="2">S/R</Th>
            </tr>
        </thead>
        {teams.map(team => (
            <tbody key={team.tid}>
                <tr>
                    <Td left colspan="12" className="cc-panel-subbar">
                        {team.lname}
                    </Td>
                </tr>
                {team.rows.map(row => <BattingPositionLeadersRow key={row.position} row={row} />)}
            </tbody>
        ))}
    </Table>
);

const BattingPositionLeadersRow = ({ row }) => {
    if (!row.pid) {
        return (
            <tr>
                <Td min="8">{row.position}</Td>
                <Td left />
                <Td min="2" />
                <Td priority="2" />
                <Td priority="2" />
                <Td priority="2" />
                <Td priority="2" />
                <Td priority="2" />
                <Td />
                <Td priority="2" />
                <Td min="2" />
                <Td priority="2" />
            </tr>
        );
    }

    return (
        <tr>
            <Td min="8">{row.position}</Td>
            <Td left>
                <PlayerLink pid={row.pid} fname={row.fname} lname={row.player_lname} />
            </Td>
            <Td min="2">{row.runs}</Td>
            <Td priority="2" className={`cc-runs-${row.bestisout.toLowerCase().replace(' ', '_')}`}>
                {row.bestruns}
            </Td>
            <Td priority="2">{row.r100s}</Td>
            <Td priority="2">{row.r50s}</Td>
            <Td priority="2">{row.fours}</Td>
            <Td priority="2">{row.sixes}</Td>
            <Td>{row.innings}</Td>
            <Td priority="2">{row.notouts}</Td>
            <Td min="2">{dp(row.average)}</Td>
            <Td priority="2">{dp(row.strike_rate, 1)}</Td>
        </tr>
    );
};



// WEBPACK FOOTER //
// ./src/views/batting-position-leaders/BattingPositionLeadersPage.jsx